import axios from "axios"
import { errorSnackMsg, successSnackMsg } from "../../component/Custom Hooks/SnackkBarUtilities"
import { setSubmitLoading } from "../../Redux/Dashboard/mainDashBoardSlice"
import store from "../../Redux/store"
import { HEADERS } from "../../API/UrlAndPaths"
import { selfDialogScreenSelected, setOngoingOrdersForSelf, setSelfSingleOrderInfo } from "../Slices/selfOrderMainSlice"
import { setSelfCustomer, setSelfMobileNo, setSelfOrderScreen } from "../Components/Order/selfOrderEssentialsSlice"
import { getFloorDetailsForBilling } from "../../component/Modules/Sales/Billing/API/billingFloorSection"

export const verifyPasswordAuthentication= async (
    body,authSuccessFn
    )=>{
    store.dispatch(setSubmitLoading(true))
    await axios.post("admin/verifypassword",body,HEADERS)
    .then((res)=>{
        if(res.status===200){
            store.dispatch(setSubmitLoading(false))
            authSuccessFn()
        }
    })
    .catch((err)=>{
        errorSnackMsg(err?.response?.status===401?"Incorrect Password" : err.message || err.response.data)
        store.dispatch(setSubmitLoading(false))
    })
}

export const singleSelfOrderInfoAPICall=async(body,postFn)=>{
    store.dispatch(setSubmitLoading(true))
    await axios.post("pos/viewPosOrderById",body,HEADERS)
    .then((res)=>{
        if(res.status===200){
                store.dispatch(setSubmitLoading(false))
                store.dispatch(setSelfSingleOrderInfo(res.data))
                postFn?.(); 
        }
        })
        .catch((err)=>{
            store.dispatch(setSubmitLoading(false))
            store.dispatch(setSelfSingleOrderInfo(null))
        })
}


export const selfSelectCustomerAPI=async(body,backState=false)=>{
    try{
        store.dispatch(setSubmitLoading(true))
        const response =await axios.post("customerPos/customerLogin",body,HEADERS)

        if(response.status===200){
            successSnackMsg("Customer fetched successfully")
            store.dispatch(setSelfCustomer(response.data?.data))
            store.dispatch(setSelfMobileNo(null))
            backState && store.dispatch(setSelfOrderScreen("orderProductLists"))

        }
    }
    catch(err){
        errorSnackMsg(err.response.data?.message)
        err.response.status===404 && store.dispatch(selfDialogScreenSelected("registerPopup"))
    }
    finally{
        store.dispatch(setSubmitLoading(false))
    }
}
export const selfAddCustomerAPI=async(body)=>{
    try{
        store.dispatch(setSubmitLoading(true))
        const response =await axios.post("account/createVendor",body,HEADERS)

        if(response.status===200){
            let {customerTopbar}=store.getState().selfOrderEssentialsSlice
            successSnackMsg("Customer added successfully")
            store.dispatch(setSelfCustomer(response.data))
            store.dispatch(setSelfMobileNo(null))
            store.dispatch(setSelfOrderScreen(customerTopbar?"orderProductLists":"loginScreen"))
        }
    }
    catch(err){
        errorSnackMsg(err.response.data)
    }
    finally{
        store.dispatch(setSubmitLoading(false))
    }
}

// Pay at counter / scan-and-pay: the customer is done but NO payment is taken here.
// This flags the order as self-completed and (backend) emits `selfordercompleted`
// so the cashier's web-billing notification popup fires and they can settle it.
export const payAtCounterSelfOrderAPI=async(body)=>{
    try{
        store.dispatch(setSubmitLoading(true))
        const response =await axios.post("pos/completeSelfOrder",body,HEADERS)

        if(response.status===200 || response.status===202){
            successSnackMsg("Order sent to counter")
            localStorage.removeItem("selfOrderId")
            store.dispatch(setSelfSingleOrderInfo(null))
            store.dispatch(setSelfOrderScreen("orderFeedbackScreen"))

            // Refresh floor + ongoing orders for STAFF/SELF views
            const userInfo = store.getState()?.loginResponseSlice?.value
            const branchId = userInfo?.branchPk
            const waiterId = userInfo?.data?._id
            const floorId = localStorage.getItem("defaultFloorId")
            if(branchId && floorId){
                getFloorDetailsForBilling({ id: floorId, branchId })
            }
            branchId && onGoingOrdersForSelf({ type: 1, waiterId, branchId })
        }
    }
    catch(err){
        errorSnackMsg(err?.response?.data)
    }
    finally{
        store.dispatch(setSubmitLoading(false))
    }
}

export const completeSelfOrderAPI=async(body)=>{
    try{
        store.dispatch(setSubmitLoading(true))
        const response =await axios.post("pos/postPosPayment",body,HEADERS)

        if(response.status===200 || response.status===202){
            successSnackMsg("Payment successful")
            localStorage.removeItem("selfOrderId")
            store.dispatch(setSelfSingleOrderInfo(null))
            store.dispatch(setSelfOrderScreen("orderFeedbackScreen"))

            // Refresh floor + ongoing orders so the completed (paid) order
            // no longer appears in the table order list for STAFF/SELF
            const userInfo = store.getState()?.loginResponseSlice?.value
            const branchId = userInfo?.branchPk
            const waiterId = userInfo?.data?._id
            const floorId = localStorage.getItem("defaultFloorId")
            if(branchId && floorId){
                getFloorDetailsForBilling({ id: floorId, branchId })
            }
            branchId && onGoingOrdersForSelf({ type: 1, waiterId, branchId })
        }
    }
    catch(err){
        errorSnackMsg(err?.response?.data)
    }
    finally{
        store.dispatch(setSubmitLoading(false))
    }
}
export const submitFeedbackSelfOrderAPI=async(body,postFn)=>{
    try{
        store.dispatch(setSubmitLoading(true))
        const response =await axios.post("pos/addSelfOrderCustReview",body,HEADERS)
        response.status===200 && postFn?.()
    }
    catch(err){
        errorSnackMsg(err?.response?.data)
    }
    finally{
        store.dispatch(setSubmitLoading(false))
    }
}


export const onGoingOrdersForSelf=async(body)=>{
    try{
        const response=await axios.post("pos/listPosOrders",body,HEADERS)

        if(response.status===200 || response.status===202){
            const orders = Array.isArray(response?.data)
                ? response.data
                : (Array.isArray(response?.data?.data) ? response.data.data : []);
            store.dispatch(setOngoingOrdersForSelf(orders))
        } else {
            store.dispatch(setOngoingOrdersForSelf([]))
        }
    }
    catch(err){
        store.dispatch(setOngoingOrdersForSelf([]))
    }
}